// @owners { team: patients-team }
import { type CartItem } from '@alto/orders_api/types/v1/cart_item';
import { type OrderPricingParams, type PriceType } from '@alto/scriptdash/alto/pricing/patients/v3/pricing_endpoint';
import { createSelector } from 'reselect';
import { getOrder } from '~shared/features/checkout/selectors/getOrder';
import { makeFetchOrderPricingOrderParam } from '~shared/features/pricing/helpers';
import type { ReduxStateShared } from '~shared/types';

type CartItemsParam = {
  cartItems: CartItem[];
};

type SelectedPaymentTypesParam = {
  selectedPaymentTypes: Record<number, PriceType>;
};

const getCartItems = (_: ReduxStateShared, props: CartItemsParam) => props?.cartItems;
const getSelectedPaymentTypes = (_: ReduxStateShared, props: SelectedPaymentTypesParam) => props.selectedPaymentTypes;

export const getFetchPricingOrderParam = createSelector(
  [getOrder, getCartItems, getSelectedPaymentTypes],
  (order, cartItems, selectedPaymentTypes): OrderPricingParams => {
    return makeFetchOrderPricingOrderParam(order, cartItems, selectedPaymentTypes);
  },
);
